<template>
  <div class="country-selector" :class="{ 'accepted': accepted }">
    <div class="country-selector__label text-campton-book">
      {{ $gettext('Business location') }}
    </div>
    <div class="country-selector__selected isoflags-f32" @click="showCountrySelector = true" :class="{ hidden: showCountrySelector }">
      <div class="flag" :class="[businesslocation.toLowerCase()]" />
      <div class="text-campton-book">{{ countryOptions[businesslocation] }}</div>
    </div>
    <div class="input-check"><font-awesome-icon icon="fa-solid fa-check" /></div>
    <b-form-group id="fieldset-signup-country" class="country-selector__selector" :class="{ visible: showCountrySelector }">
      <b-form-select
        id="input-signup-country" 
        v-model="businesslocation" 
        :options="formCountryOptions"
        @change="showCountrySelector = false"
        required
        :disabled="accepted"
      />
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
export default {
  name: 'CountrySelector',
  components: {
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    accepted: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showCountrySelector: false,
    }
  },
  computed: {
    ...mapGetters({
      countryOptions: 'main/getCountryOptions',
      supportedCountries: 'signup/getSupportedCountries',
      userCountry: 'signup/getUserCountry',
      userLanguage: 'signup/getUserLanguage',
    }),
    businesslocation: {
      get () { return this.value },
      set (businesslocation) { this.$emit('input', businesslocation) }
    },
    formCountryOptions () {
      const extracted = {}
      const remaining = {}
      for (const key in this.countryOptions) {
        if (this.supportedCountries.includes(key)) {
          extracted[key] = this.countryOptions[key]
        } else {
          remaining[key] = this.countryOptions[key]
        }
      }
      return [
        { label: this.$gettext('Supported countries'), options: extracted },
        { label: this.$gettext('Others'), options: remaining }
      ]
    },
  },
  created () {
    this.setupData()
  },
  methods: {
    ...mapActions({ 
      loadCountries: 'main/loadCountries'
    }),
    setupData () {
      // load countries
      if (this.countryOptions.length < 1) {
        this.loadingCountries = true
        this.loadCountries().then(() => {
          this.loadingCountries = false
          console.log('countries loaded', this.countryOptions)
        })
      } else {
        this.loadingCountries = false
        console.log('countries already loaded', this.countryOptions)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  .country-selector {
    $selectorHeight: 25px;
    position: relative;
    margin-bottom: 1rem;
    // padding: 0.5rem 1rem;
    padding: 0.5rem 1rem 0.25rem;
    border-radius: $radiusMd;
    border: 1px solid #dfdfdf;

    height: 56px;
    &.accepted {
      background: #f5f5f5;
      .input-check {
        opacity: 1;
        right: 1rem;
      }
    }
    &__label {
      font-size: 0.75rem;
      opacity: 0.5;
    }

    &__selected {
      position: absolute;
      display: flex;
      align-items: center;
      // gap: 0.5rem;
      height: $selectorHeight;
      font-size: 16px;
      opacity: 1;
      &.hidden { display: none; opacity: 0; }
      .flag { 
        display: block;
        width: 32px; 
        height: 32px;
        transform: scale(0.7);
        transform-origin: left;
        margin-top: -5px;
        margin-right: -5px;
      }
    }
    &__selector {
      height: $selectorHeight;
      .custom-select {
        cursor: pointer;
        padding: 0;
        height: $selectorHeight;
      }
      opacity: 0;
      margin-bottom: 0;
      &.visible { display: block; opacity: 1; }
    }
    .input-check {
      transition: all 0.3s ease;
      position: absolute;
      top: 50%;
      right: 0rem;
      transform: translateY(-50%);
      opacity: 0;
      color: $colorBrand;
      font-size: 18px;
    }

  }
</style>